/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React, {useEffect, useState, useRef} from 'react';
import PageBox from "../../layouts/pageBox";
import ListingTop from "../../components/ListingTop";
import ListingBottom from "../../components/ListingBottom";
import FiltersCars from "../../components/FiltersCars";
import CarBox from "../../components/CarBox";
import {useNavigate, useOutletContext, useParams} from "react-router-dom";
import axios from "axios";
import Loader from "../../elements/loader";
import FilterCheckbox from "../../elements/FilterCheckbox";
import useAxiosJTW from "../../Hooks/useAxiosJTW";
import {useTranslation} from "react-i18next";

const CarsListing = () => {

    let params = useParams();
    const { t, i18n } = useTranslation();
    let navigate = useNavigate();
    const scrollTop = useRef(null);

    const isInitialSort = useRef(true);

    const axiosJWT = useAxiosJTW();

    const queryParameters = new URLSearchParams(window.location.search);
    const [dataToSend, setDataToSend] = useState({
        page : queryParameters.get("page")||1,
        sort: queryParameters.get("sort")||'date-desc',
        criteria: queryParameters.get("criteria"),
        make_id: queryParameters.get("make_id"),
        model: queryParameters.get("model"),
        year: queryParameters.get("year"),
        fuel: queryParameters.get("fuel"),
        city: queryParameters.get("city"),
        limit: queryParameters.get("limit")||50
    });

    const [ads, setAds] = useState([]);
    const [criteria, setCriteria] = useState([]);

    const [sortValue, setSortValue] = useState('date-desc');
    const [totalPages, setTotalPages] = useState(1);
    const [totalItems, setTotalItems] = useState(0);

    const [isLoading, setIsLoading] = useState(true);
    const [filterLoading, setFilterLoading] = useState(true);

    const dataText = {
        title: 'Damages Repairables',
        subtitle: ''
    };

    const controller = new AbortController();
    const signal= controller.signal;

    const getads = ( signal) => {
        axiosJWT.post('api/getads', {
            has_ads: '1',
            filter: '1',
            page : queryParameters.get("page")||1,
            sort: queryParameters.get("sort")||'date-desc',
            criteria: queryParameters.get("criteria"),
            make_id: queryParameters.get("make_id"),
            model: queryParameters.get("model"),
            year: queryParameters.get("year"),
            fuel: queryParameters.get("fuel"),
            city: queryParameters.get("city"),
            limit: queryParameters.get("limit")||50
        }, {signal}).then( (response) => {

            if(response.status === 200){

                setAds(response.data.ads || []);

                if( response.data.criteria ){
                    setCriteria(response.data.criteria);
                }

                setTotalPages( parseInt(response.data.total_pages) || 1 );
                setTotalItems(  parseInt(response.data.total_ads) );

                setIsLoading(false);
                setFilterLoading(false);
            }
        } ).catch((error) => {
            console.log(error);
        });

    }


    useEffect(() => {
        setIsLoading(true);

        getads( signal);

        return () => {controller.abort();}
    }, [params]);



    useEffect(() => {
        if (isInitialSort.current) {
            isInitialSort.current = false;
        } else {

            const _criteria = queryParameters.get("criteria");
            const _make_id = queryParameters.get("make_id");
            const _model = queryParameters.get("model");
            const _year = queryParameters.get("year");
            const _fuel = queryParameters.get("fuel");
            const _city = queryParameters.get("city");
            const _limit = queryParameters.get("limit")||50;

            const _url = `/${i18n.language}/cars/search/?sort=
                ${sortValue}
                &page=1
                ${_limit ? `&limit=${_limit}` : ''}
                ${_make_id ? `&make_id=${_make_id}` : ''}
                ${_model ? `&model=${_model}` : ''}
                ${_year ? `&year=${_year}` : ''}
                ${_fuel ? `&fuel=${_fuel}` : ''}
                ${_city ? `&city=${_city}` : ''}
            `;

            navigate(_url.replace(/\s+/g, ''));
        }
        return () => {controller.abort();}
    }, [sortValue]);

    function onSubmitFilters(value){

        const _sort = queryParameters.get("sort")||'date-desc';
        const _criteria = queryParameters.get("criteria");
        const _limit = queryParameters.get("limit")||50;

        const _url = `/${i18n.language}/cars/search/?sort=
                ${_sort ? `&sort=${_sort}` : ''}
                &page=1
                ${_limit ? `&limit=${_limit}` : ''}
                ${value.make_id ? `&make_id=${value.make_id}` : ''}
                ${value.model_name ? `&model=${value.model_name}` : ''}
                ${value.years ? `&year=${value.years}` : ''}
                ${value.fuel ? `&fuel=${value.fuel}` : ''}
                ${value.city ? `&city=${value.city}` : ''}
            `;

        navigate(_url.replace(/\s+/g, ''));
    }

    function onResetFilters(){

        const _sort = queryParameters.get("sort")||'date-desc';
        const _criteria = queryParameters.get("criteria");
        const _limit = queryParameters.get("limit")||50;

        const _url = `/${i18n.language}/cars/search/?sort=
                ${_sort ? `&sort=${_sort}` : ''}
                &page=1
                ${_limit ? `&limit=${_limit}` : ''}
            `;

        navigate(_url.replace(/\s+/g, ''));
    }

    return (
        <PageBox data={dataText}>
            <div className='page-body'>
                <div ref={scrollTop} className='page-row'>
                    <div className='page-sidebar'>

                        {filterLoading ? (
                            <div style={{ paddingTop: '30px', textAlign : 'center' }}><Loader/></div>
                        ) : (
                            <>
                                <FiltersCars
                                    onReset={onResetFilters}
                                    onSubmit={onSubmitFilters}
                                />
                                <div className='pt-5'>
                                    {
                                        criteria.map( (item, index) => (
                                            <FilterCheckbox selected={dataToSend.criteria} onSelect={setDataToSend} filter={item} key={index}/>
                                        ) )
                                    }
                                </div>
                            </>
                        )}

                    </div>
                    <div className='page-content'>

                        <ListingTop value={sortValue} onSort={setSortValue} count={totalItems}/>

                        <div className='carBoxs'>
                            {isLoading ? (
                                <div style={{ paddingTop: '30px', textAlign : 'center', margin: '0 auto' }}><Loader/></div>
                            ) : (
                                ads.map((item, index) => {
                                    return(
                                        <CarBox key={index} ad={item}/>
                                    );
                                })
                            )}
                        </div>

                        <ListingBottom currentPage={dataToSend.page} totalPages={totalPages} onChangePage={setDataToSend} scrollTop={scrollTop} green={true}/>

                    </div>
                </div>

            </div>
        </PageBox>
    );
};

export default CarsListing;
